import { DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY } from '../../constants/microfrontends';
import { useApplicationContext } from '../../containers/ApplicationContext';
import { IManifestInfo } from '../../types/manifestInfo';

export function useIsDesktopFiltersMicrofrontendEnabled(): boolean {
  const { config } = useApplicationContext();

  const isRsEnabled = config.get<boolean>('Dailyrent.DesktopFiltersMicrofrontend.Enabled') ?? false;
  const manifestInfo = config.get<IManifestInfo | null>(DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY);

  return isRsEnabled && manifestInfo !== null && manifestInfo !== undefined;
}
